<template>
  <div
    class="widgets-outer-casing scroll-touch"
    @click="$emit('click')"
    :style="widgetStyle"
  >
  <slot />
  </div>
</template>

<script>
export default {
  computed: {
    widgetStyle() {
      return `height: ${this.$root.clientHeight}px;`;
    }
  },
  mounted() {
    this.$nextTick(() => this.$emit('load'));
  }
}
</script>
<style scoped lang="stylus">
  .widgets-outer-casing {
    width: 100%;
    position: relative;
  }
</style>